import axios from 'axios';
import { getDataOptions } from './backendServices';
import { COURSE_SERVICE_BASE_URL } from './environments';

const COURSES_API = 'course/getDetails';

// Services
export const getCoursesService = async (courseSlug, autoEnrol, courseId) => {
  try {
    const response = await axios(
      getDataOptions(COURSE_SERVICE_BASE_URL, COURSES_API + `?isExclusive=true&` + (courseSlug ? `courseSlug=${courseSlug}` : `courseId=${courseId}`)),
      true
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
